/**
 * @generated SignedSource<<6484f7e7b316501823209660cbd9b426>>
 * @relayHash 687fae66bdb112eae10f29089536fe8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 148b48052e78290e2bd9bdd57f768952d26688f78faeb203f683ba7a3656b88a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholderCommsSearchField = "EMAIL_ID" | "%future added value";
export type StakeholderCommsStakeholderStatus = "ACTIVE" | "DELETED" | "INVITED" | "INVITED_PENDING_APPROVAL" | "NOT_INVITED" | "PENDING_IDENTITY_SETUP" | "QUARANTINED" | "%future added value";
export type StakeholderCommsStakeholderType = "EXTERNAL" | "GROUP" | "INTERNAL" | "TEAM" | "%future added value";
export type StakeholderCommsStakeholderConnectionFilter = {
  status?: ReadonlyArray<StakeholderCommsStakeholderStatus> | null;
  type?: ReadonlyArray<StakeholderCommsStakeholderType> | null;
};
export type StakeholderCommsStakeholderConnectionSearch = {
  searchField?: StakeholderCommsSearchField | null;
  searchValue?: string | null;
};
export type StakeholdersPageQuery$variables = {
  after?: string | null;
  cloudId?: string | null;
  filter?: StakeholderCommsStakeholderConnectionFilter | null;
  first: number;
  search?: StakeholderCommsStakeholderConnectionSearch | null;
};
export type StakeholdersPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StakeholderPageContent">;
};
export type StakeholdersPageQuery = {
  response: StakeholdersPageQuery$data;
  variables: StakeholdersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "StakeholderPageContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "StakeholderCommsStakeholderConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_listStakeholders",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholderEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "StakeholderCommsStakeholder",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "aaid"
                  },
                  {
                    "concreteType": "StakeholderCommsNotificationPreference",
                    "kind": "LinkedField",
                    "name": "notificationPreference",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "emailId"
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  {
                    "concreteType": "StakeholderCommsGroups",
                    "kind": "LinkedField",
                    "name": "groups",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "avatar"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "error"
          },
          {
            "concreteType": "StakeholderCommsPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v6/*: any*/),
        "filters": [
          "filter",
          "search",
          "cloudId"
        ],
        "handle": "connection",
        "key": "StakeholderTableLayout_stakeholderComms_listStakeholders",
        "kind": "LinkedHandle",
        "name": "stakeholderComms_listStakeholders"
      }
    ]
  },
  "params": {
    "id": "148b48052e78290e2bd9bdd57f768952d26688f78faeb203f683ba7a3656b88a",
    "metadata": {},
    "name": "StakeholdersPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a5f07351b622cbddbb59763c3b659564";

export default node;
